import { useClientLabel } from '@/lib/hooks/use-client-label'
import { useServiceLabel } from '@/lib/hooks/use-service-label'

interface OrderFieldsProps {
    preInstructions: string
    onPreInstructionsChange: (value: string) => void
    postInstructions: string
    onPostInstructionsChange: (value: string) => void
}

export default function OrderFields({
    preInstructions,
    onPreInstructionsChange,
    postInstructions,
    onPostInstructionsChange,
}: OrderFieldsProps) {
    const { Order } = useServiceLabel()
    const { clientLabel } = useClientLabel()

    return (
        <>
            <div className="form-control w-full">
                <label className="label">
                    <span className="label-text font-medium">
                        Instruções Pré-{Order}
                    </span>
                </label>
                <textarea
                    className="textarea textarea-bordered w-full"
                    placeholder={`Instruções para o ${clientLabel} antes do ${Order.toLowerCase()}...`}
                    value={preInstructions}
                    onChange={e => onPreInstructionsChange(e.target.value)}
                    rows={3}
                />
            </div>

            <div className="form-control w-full mt-4">
                <label className="label">
                    <span className="label-text font-medium">
                        Instruções Pós-{Order}
                    </span>
                </label>
                <textarea
                    className="textarea textarea-bordered w-full"
                    placeholder={`Instruções para o ${clientLabel} após o ${Order.toLowerCase()}...`}
                    value={postInstructions}
                    onChange={e => onPostInstructionsChange(e.target.value)}
                    rows={3}
                />
            </div>
        </>
    )
}
